export const policyImages = [
  '/assets/images/policies/Pernyataan Polisi Keraian dan Hospitaliti.jpg',
  '/assets/images/policies/Pernyataan polisi konflik kepentingan.jpg',
  '/assets/images/policies/Polisi Alam Sekitar.jpg',
  '/assets/images/policies/Polisi Hadiah 1.jpg',
  '/assets/images/policies/Polisi Hadiah 2.jpg',
  '/assets/images/policies/Polisi KSSB Gangguan Seksual 1.jpg',
  '/assets/images/policies/Polisi KSSB Gangguan Seksual 2.jpg',
  '/assets/images/policies/Polisi Kelestarian.jpg',
  '/assets/images/policies/Polisi Kesihatan.jpg',
  '/assets/images/policies/Polisi Konflik Kepentingan.jpg',
  '/assets/images/policies/Polisi Kualiti.jpg',
  '/assets/images/policies/Polisi Pemberian Maklumat.jpg',
  '/assets/images/policies/Polisi Pencegahan Rasuah.jpg',
  '/assets/images/policies/Polisi Pengurusan Keselamatan Maklumat.jpg',
  '/assets/images/policies/Polisi Perlindungan Data Peribadi.jpg'
];
